import { useCallback, useMemo } from "react";
import useGetMySelf from "@/features/auth/use-get-my-self";
import useIdentity from "@/features/ui/hooks/use-identity";
import AppSelect from "@/features/line-sheet-sets/app-select";
import { Company } from "@/features/types";
import { getDefaultPageByIdentity } from "@/pages";
import {
  getIdentity,
  selectCompany,
} from "@/features/ui/helpers/identity-helpers";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { resolveTrafficType } from "@/shared/analytics/traffic-type";
import { rememberTrafficType } from "@/shared/analytics/traffic-type-storage";

export default function AppIdentitySelector() {
  const identity = useIdentity();
  const { data: user } = useGetMySelf();
  const { tTitle } = useI18nHelper();

  const handleSelect = useCallback(
    (value: Company | undefined) => {
      if (value) {
        selectCompany(value.id);
        // 회사 전환은 문서를 리로드하므로, 리로드 후 첫 히트가 새 회사 기준으로
        // 찍히도록 여기서 traffic_type 을 남긴다. getIdentity() 는 sessionStorage 를
        // 다시 읽어 방금 고른 회사를 이미 반영한다.
        rememberTrafficType(resolveTrafficType(getIdentity()));
        window.location.replace(getDefaultPageByIdentity(getIdentity()));
      }
    },
    []
  );

  const value = useMemo((): Company | undefined => {
    if (identity && user) {
      return user.companies.find((c) => c.id === identity.company?.id);
    }
  }, [identity, user]);

  const options = useMemo((): AppSelectOption<Company>[] => {
    if (user && user.companies) {
      return user.companies.map((c) => ({
        name: `[${c.type}] ${c.orgName}`,
        value: c,
      }));
    }
    return [];
  }, [user]);

  return (
    <AppSelect<Company>
      name={tTitle("select_company")}
      value={value}
      width={"180px"}
      mobileSheet={true}
      idFunc={(c) => c.id}
      options={options}
      isClearable={false}
      onSelect={handleSelect}
    />
  );
}
